/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTask200ResponseSchema } from '../models/CreateTask200ResponseSchema';
import type { CreateTaskRequestSchema } from '../models/CreateTaskRequestSchema';
import type { GetPutPresignedUrl200ResponseSchema } from '../models/GetPutPresignedUrl200ResponseSchema';
import type { GetPutPresignedUrlRequestSchema } from '../models/GetPutPresignedUrlRequestSchema';
import type { GetTask200ResponseSchema } from '../models/GetTask200ResponseSchema';
import type { GetTaskRequestSchema } from '../models/GetTaskRequestSchema';
import type { ListChallengeTasks200ResponseSchema } from '../models/ListChallengeTasks200ResponseSchema';
import type { ListChallengeTasksRequestSchema } from '../models/ListChallengeTasksRequestSchema';
import type { UpdateTask200ResponseSchema } from '../models/UpdateTask200ResponseSchema';
import type { UpdateTaskRequestSchema } from '../models/UpdateTaskRequestSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TasksService {

    /**
     * getTask
     * Gets task
     * @param requestBody
     * @returns GetTask200ResponseSchema GetTask200Response
     * @throws ApiError
     */
    public static getTask(
        requestBody?: GetTaskRequestSchema,
    ): CancelablePromise<GetTask200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getTask',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetTask400Response`,
                404: `GetTask404Response`,
            },
        });
    }

    /**
     * listChallengeTasks
     * list challenge task
     * @param requestBody
     * @returns ListChallengeTasks200ResponseSchema ListChallengeTasks200Response
     * @throws ApiError
     */
    public static listChallengeTasks(
        requestBody?: ListChallengeTasksRequestSchema,
    ): CancelablePromise<ListChallengeTasks200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listChallengeTasks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListChallengeTasks400Response`,
            },
        });
    }

    /**
     * updateTask
     * update task
     * @param requestBody
     * @returns UpdateTask200ResponseSchema UpdateTask200Response
     * @throws ApiError
     */
    public static updateTask(
        requestBody?: UpdateTaskRequestSchema,
    ): CancelablePromise<UpdateTask200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateTask',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateTask400Response`,
            },
        });
    }

    /**
     * createTask
     * create task
     * @param requestBody
     * @returns CreateTask200ResponseSchema CreateTask200Response
     * @throws ApiError
     */
    public static createTask(
        requestBody?: CreateTaskRequestSchema,
    ): CancelablePromise<CreateTask200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/createTask',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `CreateTask400Response`,
            },
        });
    }

    /**
     * getPutPresignedUrl
     * Get Put presigned url
     * @param requestBody
     * @returns GetPutPresignedUrl200ResponseSchema GetPutPresignedUrl200Response
     * @throws ApiError
     */
    public static getPutPresignedUrl(
        requestBody?: GetPutPresignedUrlRequestSchema,
    ): CancelablePromise<GetPutPresignedUrl200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getPutPresignedUrl',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetPutPresignedUrl400Response`,
            },
        });
    }

}
